module.exports = __webpack_public_path__ + "static/media/bi-logo.443b8a2e.png";